import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { OrderListItem } from 'reg-hub-common';
import { OrderListRepositoryService } from '../../services/order-list/order-list-repository.service';

@Component({
    selector: 'app-order-list',
    templateUrl: './order-list.component.html',
    styleUrls: ['./order-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrderListComponent {
  @Input() data: OrderListItem[] = [];
  @Input() total: number = 0;
  @Input() loading: boolean = false;
  @Input() displayedColumns = [
    'referenceNumber',
    'orderTypeID',
    'jurisdiction',
    'orderStatusTypeID',
    'messages'
  ]

  constructor(
    protected repo: OrderListRepositoryService,
    protected router: Router) { }

  protected onViewAll() {
    let params = {
      status: 'Pending',
      isVisible: 'true',
      sortColumn: 'priority',
      sortDirection: 'asc'
    }

    this.router.navigate(['/orders'], { queryParams: params })
  }

  protected navigateToOrder(orderID: string) {
    this.router.navigate(['orders', orderID]);
  }
}
